import { makeAutoObservable } from "mobx";

class PermissionStore {
  // An array to hold the list of permissions
  permissions: string[] = [];
  permissionsLoaded: boolean = false; // New state for permission loading

  constructor() {
    makeAutoObservable(this);
  }

  // Action to set the permissions loaded state
  setPermissionsLoaded(loaded: boolean): void {
    this.permissionsLoaded = loaded;
  }

  // Computed property to check if permissions are loaded
  isPermissionsLoaded(): boolean {
    return this.permissionsLoaded;
  }

  // Action to set or replace the entire permissions list
  setPermissions(permissions: string[]): void {
    this.permissions = permissions;
  }

  // Action to add a new permission to the list
  addPermission(permission: string): void {
    if (!this.permissions.includes(permission)) {
      this.permissions.push(permission);
    }
  }

  // Action to remove a permission from the list
  removePermission(permission: string): void {
    this.permissions = this.permissions.filter((p) => p !== permission);
  }

  // Computed property to check if a permission exists
  hasPermission(permission: string): boolean {
    return this.permissions.includes(permission);
  }
}

export default PermissionStore;
